export default {"src":"/_next/static/media/cricket.d05ac187.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};